import * as React from 'react';
import { getSchema } from '../../utils';
import { BackTag, CancelX } from '../Icon/icon';
import './backTagForm.scss';
import { useSelector } from '../../utils/useSelector';
import { NodeType } from '../../enums/NodeType';
import { Field } from '../MetadataForm/metadataFormField';
import { FormUpdater } from '../../types/Field';

interface BacktagFormProps {
  showHideBacktagWidget?: () => any;
  shouldShowBacktags?: boolean;
  updater: FormUpdater;
  isMetricsVisible?: boolean;
}

export const BacktagForm = ({
  showHideBacktagWidget,
  shouldShowBacktags,
  isMetricsVisible,
  updater
}: BacktagFormProps) => {
  return (
    <div className="backtag-container">
      <a
        onClick={e => {
          showHideBacktagWidget();
        }}
        className={`backtag-icon ${shouldShowBacktags ? 'active ' : ''} ${
          !isMetricsVisible ? 'elevated' : ''
        }`}
      >
        <BackTag />
      </a>
      {shouldShowBacktags && (
        <div className="backtag-form scrollable">
          <div className="header-row">
            <div className="header">Backtagging</div>
            {shouldShowBacktags && (
              <a
                onClick={e => {
                  showHideBacktagWidget();
                }}
                className="close-backtagform"
              >
                <CancelX />
              </a>
            )}
          </div>
          <BackTagFields updater={updater} />
        </div>
      )}
    </div>
  );
};

interface BackTagFieldsProps {
  updater: FormUpdater;
}

const BackTagFields = ({ updater }: Pick<BackTagFieldsProps, 'updater'>) => {
  const data = useSelector(s => s.form?.data);
  const schemas = useSelector(s => s?.planning?.selectedWorkspace?.schemas);
  const itemSchema = React.useMemo(
    () => ({ ...getSchema(schemas, NodeType.Item), schemaForms: null }),
    [schemas]
  );
  const backtagFields = itemSchema?.props?.fields?.filter(
    f => f.parentField == 'backtag'
  );

  if (!backtagFields?.length) return null;

  return (
    <div className="backtag-fields">
      <div className="metadata-form">
        {backtagFields.map(field => {
          return (
            <Field
              key={field.field}
              field={field}
              data={data}
              schema={itemSchema}
              schemas={schemas}
              updater={updater}
            />
          );
        })}
      </div>
    </div>
  );
};
